import { useLayoutEffect, useRef, useState } from "react";
import { countCents, HERO_COUNT_MS } from "@/lib/feel";
import { prefersReducedMotion } from "@/lib/motion";
let opened = false;
/** The owning mount can resume an effect replay, but later tab visits cannot restart the count. */
export function useHeroCount(final: number, ready: boolean, enabled = true): number {
  const [display, setDisplay] = useState<number | null>(null);
  const latest = useRef(final);
  const start = useRef<number | null>(null);
  const finished = useRef(false);
  latest.current = final;
  useLayoutEffect(() => {
    if (!ready || !enabled || finished.current || (opened && start.current === null)) return;
    opened = true;
    if (prefersReducedMotion() || document.hidden) { finished.current = true; return; }
    start.current ??= performance.now();
    const began = start.current;
    let frame = 0;
    setDisplay(0);
    const finish = (): void => { cancelAnimationFrame(frame); finished.current = true; setDisplay(null); };
    const tick = (now: number): void => {
      const progress = (now - began) / HERO_COUNT_MS;
      if (progress >= 1 || prefersReducedMotion() || document.hidden) { finish(); return; }
      setDisplay(countCents(latest.current, progress));
      frame = requestAnimationFrame(tick);
    };
    const visibility = (): void => { if (document.hidden) finish(); };
    document.addEventListener("visibilitychange", visibility);
    frame = requestAnimationFrame(tick);
    return () => { cancelAnimationFrame(frame); document.removeEventListener("visibilitychange", visibility); };
  }, [ready, enabled]);
  return display ?? final;
}
